import React from 'react'
// libs
import { useDispatch, useSelector } from 'react-redux'
import { change, formValueSelector } from 'redux-form'
// components
import Preview from './components/Preview'
import DataFields from './components/DataFields'
import PlainSelect from './components/PlainSelect'
import SchemaFields from './components/SchemaFields'
import { ReduxInput, ReduxSwitch } from 'components/FormElements'
// constants
import { Forms } from 'constants/forms'
import { CHART_TYPE_OPTIONS } from 'constants/charts'
// schemas
import { CHART_DISPLAY_SCHEMA, CHART_TRANSFORM_SCHEMA } from './components/SchemaFields/schema'
// types
import { ChartType } from 'types/charts'
import { IOption } from 'components/FormElements/Select'
// views
import { Row, ScrollArea, Wrapper } from './views'
// utils
import { required } from 'utils/validators'
import { normalizeChartConfig } from 'utils/charts/config'

const selector = formValueSelector(Forms.DASHBOARD_WIDGET_SETTINGS_FORM)

const ChartFields: React.FC = () => {
  const dispatch = useDispatch()

  const chartConfig = useSelector((state) => selector(state, 'chartConfig'))

  const chartType: ChartType = chartConfig?.type || ChartType.Bar

  // A pie and a line want different labels and tooltips: a new type starts from its own defaults, the data stays
  const onTypeChange = (option: IOption | null) => {
    if (!option) {
      return
    }

    const config = normalizeChartConfig({ type: option.value as ChartType, query: chartConfig.query })

    dispatch(change(Forms.DASHBOARD_WIDGET_SETTINGS_FORM, 'chartConfig', config))
  }

  return (
    <Wrapper>
      <Preview />
      <ScrollArea>
        <ReduxInput label='Chart title' name='chartTitle' validate={required} />
        <PlainSelect
          label='Chart type'
          name='chartConfig.type'
          options={CHART_TYPE_OPTIONS}
          onSelectChange={onTypeChange}
        />
        <ReduxSwitch label='Show title' name='showTitle' />
        <Row>
          <ReduxInput name='width' label='Width (%)' type='number' />
          <ReduxInput name='height' label='Height (px)' type='number' />
        </Row>
        <DataFields chartType={chartType} />
        <SchemaFields
          name='chartConfig'
          node={{ properties: { transform: CHART_TRANSFORM_SCHEMA } }}
          chartType={chartType}
        />
        <SchemaFields name='chartConfig.display' node={CHART_DISPLAY_SCHEMA} chartType={chartType} />
      </ScrollArea>
    </Wrapper>
  )
}

export default ChartFields
